import 'component/css/pop-msg.css';
import React from 'react';

class PopMessage extends React.Component
{
  render()
  {
    return (
      <div className={`pop-msg ${this.props.type}`}>
        <div className="pop-head">{ this.props.title }</div>
        <div className="pop-body">{ this.props.message }</div>
      </div>
    );
  }
}

class PopMessageList extends React.Component
{
  constructor(props)
  {
    super(props);
    g_ins = this; // capture rendered instance
    this.state = {
      msgs: []
    };
  }
  add(msg) {
    this.state.msgs.push(msg);
    this.forceUpdate();
    window.setTimeout(() => {
      this.state.msgs.shift();
      this.forceUpdate();
    }, g_duration);
  }

  render()
  {
    return (
      <div className="pop-msg-frame">
        { this.state.msgs.map((m,i) => <PopMessage key={`popm-${i}`} {...m} />) }
      </div>
    );
  }
}

class PopMessageController
{
  get Instance() { return _ins_list; }
  set AnimationDuration(v) { g_duration = v; }
  show(message='Message', title='', type='info')
  {
    g_ins.add({ message, title, type });
  }
}

let g_ins;
let g_duration = 5000;

const _ins_list = <PopMessageList />;
const _ins_ctrl = new PopMessageController();
export default _ins_ctrl;

window.PopMessage = _ins_ctrl;